"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSuggestedActionsAccessKey;

var _useWebChatUIContext2 = _interopRequireDefault(require("./useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSuggestedActionsAccessKey() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      suggestedActionsAccessKey = _useWebChatUIContext.suggestedActionsAccessKey;

  return [suggestedActionsAccessKey];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VTdWdnZXN0ZWRBY3Rpb25zQWNjZXNzS2V5LmpzIl0sIm5hbWVzIjpbInVzZVN1Z2dlc3RlZEFjdGlvbnNBY2Nlc3NLZXkiLCJzdWdnZXN0ZWRBY3Rpb25zQWNjZXNzS2V5Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSw0QkFBVCxHQUF3QztBQUNyRCw2QkFBc0Msb0NBQXRDO0FBQUEsTUFBUUMseUJBQVIsd0JBQVFBLHlCQUFSOztBQUVBLFNBQU8sQ0FBQ0EseUJBQUQsQ0FBUDtBQUNEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdFVJQ29udGV4dCBmcm9tICcuL3VzZVdlYkNoYXRVSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VTdWdnZXN0ZWRBY3Rpb25zQWNjZXNzS2V5KCkge1xuICBjb25zdCB7IHN1Z2dlc3RlZEFjdGlvbnNBY2Nlc3NLZXkgfSA9IHVzZVdlYkNoYXRVSUNvbnRleHQoKTtcblxuICByZXR1cm4gW3N1Z2dlc3RlZEFjdGlvbnNBY2Nlc3NLZXldO1xufVxuIl19